export default [
  {
    text: 'Без отделки',
    value: 'without',
  },
  {
    text: 'Черновая',
    value: 'rough',
  },
  {
    text: 'Чистовая',
    value: 'fine',
  },
];
